/* Rod Armour — PDP-only cp-* hydrators (Opus 4.7 12-May)
   Bundle of: ra-cp-video-slider, ra-cp-size-guide, ra-cp-hero-video, ra-cp-product-hotspots.
   Each hydrator is idempotent + DOM-attribute-based — no global namespace pollution.
   ra-cp-scrolling-announcement stays separate (loads on every page, not just PDP).
*/


/* === ra-cp-video-slider.js === */
/* Rod Armour — cp-video-slider hydrator (Opus 4.7 12-May)
   Extracted from inline <script> in sections/cp-video-slider.liquid.
   Hydrates every [data-cp-video-slider] instance on the page. */
(function () {
  function initSlider(root) {
    if (root.dataset.cpVidHydrated === 'true') return;
    root.dataset.cpVidHydrated = 'true';

    var track = root.querySelector('[data-vid-track]');
    if (!track) return;
    var prev = root.querySelector('[data-vid-prev]');
    var next = root.querySelector('[data-vid-next]');
    var slides = Array.from(track.querySelectorAll('[data-vid-slide]'));
    var forceMute = root.getAttribute('data-force-mute') === 'true';

    function step() {
      var s = track.querySelector('[data-vid-slide]');
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return (s ? s.offsetWidth : 300) + gap;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });

    function pauseAllExcept(except) {
      track.querySelectorAll('[data-vid-el]').forEach(function (v) {
        if (v !== except && !v.paused) v.pause();
      });
    }

    function enforceMuted(video) {
      if (!forceMute || !video) return;
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute('muted', '');
      try { if (video.volume !== 0) video.volume = 0; } catch (e) {}
    }

    function mountVideo(slide, trigger) {
      var existing = slide.querySelector('[data-vid-el]');
      if (existing) return existing;
      var src = trigger.getAttribute('data-video-src');
      if (!src) return null;
      var videoWidth = trigger.getAttribute('data-video-width') || 600;
      var videoHeight = trigger.getAttribute('data-video-height') || 1067;

      var video = document.createElement('video');
      video.setAttribute('data-vid-el', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      video.playsInline = true;
      video.controls = true;
      video.preload = 'metadata';
      video.poster = trigger.getAttribute('data-video-poster') || '';
      video.width = videoWidth;
      video.height = videoHeight;
      slide.style.setProperty('--ra-vid-slide-aspect', videoWidth + ' / ' + videoHeight);
      enforceMuted(video);
      video.src = src;

      slide.appendChild(video);
      slide.classList.add('is-loaded');
      video.addEventListener('play', function () {
        enforceMuted(video);
        pauseAllExcept(video);
      });
      video.addEventListener('volumechange', function () { enforceMuted(video); });
      return video;
    }

    track.querySelectorAll('[data-vid-launch]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var slide = btn.closest('[data-vid-slide]');
        var video = mountVideo(slide, btn);
        if (!video) return;
        enforceMuted(video);
        pauseAllExcept(video);
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });
  }

  function hydrateAll() {
    document.querySelectorAll('[data-cp-video-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-cp-video-slider]').forEach(initSlider);
  });
})();

/* === ra-cp-size-guide.js === */
/* Rod Armour — cp-size-guide modal hydrator (Opus 4.7 12-May)
   Extracted from inline <script> in sections/cp-size-guide.liquid.
   Each template element carries its config via data attributes. */
(function () {
  function initSizeGuide(tpl) {
    if (tpl.dataset.cpSgHydrated === 'true') return;
    tpl.dataset.cpSgHydrated = 'true';

    var sid = tpl.dataset.sgId;
    var pos = tpl.dataset.sgPosition || 'below_price';
    var modal = document.getElementById('cp-size-guide-modal-' + sid);
    if (!modal) return;
    var lastTrigger = null;

    function openModal(openBtn) {
      lastTrigger = openBtn || null;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.documentElement.classList.add('ra-size-modal-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) modal.close();
      else modal.removeAttribute('open');
    }

    function cleanupModal() {
      document.documentElement.classList.remove('ra-size-modal-open');
      document.body.style.overflow = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    function mount() {
      var scope = document.querySelector('[data-product-blocks]') || document;
      var selector, where;
      switch (pos) {
        case 'below_title':       selector = '.product-single__title'; where = 'afterend'; break;
        case 'above_title':       selector = '.product-single__title'; where = 'beforebegin'; break;
        case 'below_description': selector = '.product-block--tab'; where = 'afterend'; break;
        case 'above_description': selector = '.product-block--tab'; where = 'beforebegin'; break;
        case 'below_price':       selector = '.product-block--price'; where = 'afterend'; break;
        case 'below_atc':         selector = '.ra-qty-atc-row, .product-form__cart-submit'; where = 'afterend'; break;
        default:                  selector = '.button--add-to-cart, .product-form, .product-single__add-to-cart, .ProductForm__BuyButtons, .add-to-cart'; where = 'beforebegin';
      }
      var target = scope.querySelector(selector);
      if (!target) return;
      var existing = scope.querySelector('[data-sg-for="' + sid + '"]');
      if (existing) existing.remove();
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-sg-for', sid);
      target.insertAdjacentElement(where, node);
      var openBtn = node.querySelector('[data-sg-open]');
      if (openBtn) {
        openBtn.addEventListener('click', function () {
          openModal(openBtn);
        });
      }
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    var closeBtn = modal.querySelector('[data-sg-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('close', cleanupModal);
    modal.addEventListener('cancel', cleanupModal);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.detail && String(sid).indexOf(e.detail.sectionId) !== -1) mount();
    });
  }

  function hydrateAll() {
    document.querySelectorAll('template[data-cp-size-guide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('template[data-cp-size-guide]').forEach(initSizeGuide);
  });
})();

/* === ra-cp-hero-video.js === */
/* Rod Armour — hero-video play-trigger hydrator (Opus 4.7 12-May)
   Extracted from inline <script> in sections/hero-video.liquid.
   Mounts a video element on first click of the play trigger. */
(function () {
  function getYouTubeEmbedSource(src) {
    try {
      var url = new URL(src, window.location.href);
      var host = url.hostname.replace(/^www\./, '');
      var id = '';

      if (host === 'youtu.be') {
        id = url.pathname.split('/').filter(Boolean)[0] || '';
      } else if (host.indexOf('youtube.com') !== -1) {
        if (url.pathname.indexOf('/embed/') === 0) {
          id = url.pathname.split('/embed/')[1].split('/')[0];
        } else {
          id = url.searchParams.get('v') || '';
        }
      }

      if (!id) return '';

      var start = url.searchParams.get('start') || url.searchParams.get('t') || '';
      start = String(start).replace(/s$/, '');

      var embed = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
      if (/^\d+$/.test(start)) {
        embed += '&start=' + start;
      }

      return embed;
    } catch (error) {
      return '';
    }
  }

  function applyVideoAspect(root, media) {
    if (!root || !media || !media.videoWidth || !media.videoHeight) return;
    var aspect = media.videoWidth + ' / ' + media.videoHeight;
    var hero = root.closest('.hero--pdp-play') || root;
    hero.style.setProperty('--ra-pdp-video-aspect', aspect);
    root.style.setProperty('--ra-pdp-video-aspect', aspect);
  }

  function watchVideoAspect(root, media) {
    if (!root || !media || media.dataset.raAspectWatched === 'true') return;
    media.dataset.raAspectWatched = 'true';

    if (media.readyState >= 1) {
      applyVideoAspect(root, media);
      return;
    }

    media.addEventListener('loadedmetadata', function () {
      applyVideoAspect(root, media);
    }, { once: true });
  }

  function initHero(root) {
    if (root.dataset.cpHeroHydrated === 'true') return;
    root.dataset.cpHeroHydrated = 'true';

    var trigger = root.querySelector('[data-pdp-video-trigger]');
    if (!trigger) return;
    var initialVideo = root.querySelector('video.hero__poster-video');
    if (initialVideo) watchVideoAspect(root, initialVideo);

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (root.classList.contains('is-playing')) return;
      var src = trigger.getAttribute('data-video-src');
      if (!src) return;
      var poster = trigger.getAttribute('data-video-poster') || '';
      var existingVideo = root.querySelector('video.hero__poster-video');

      var youtubeSource = getYouTubeEmbedSource(src);
      var media;

      if (existingVideo && !youtubeSource) {
        media = existingVideo;
        media.classList.add('hero__interactive-video');
        media.controls = true;
        media.autoplay = true;
        media.playsInline = true;
        media.setAttribute('playsinline', '');
        media.setAttribute('controls', '');
        watchVideoAspect(root, media);
      } else if (youtubeSource) {
        media = document.createElement('iframe');
        media.className = 'hero__interactive-video';
        media.src = youtubeSource;
        media.title = trigger.getAttribute('aria-label') || 'Product video';
        media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        media.setAttribute('allowfullscreen', '');
        media.loading = 'eager';
      } else {
        media = document.createElement('video');
        media.className = 'hero__interactive-video';
        media.controls = true;
        media.autoplay = true;
        media.playsInline = true;
        media.preload = 'metadata';
        media.setAttribute('playsinline', '');
        media.setAttribute('controls', '');
        if (poster) {
          media.poster = poster;
          media.setAttribute('poster', poster);
        }
        media.src = src;
        watchVideoAspect(root, media);
      }

      if (!media.parentNode) {
        root.appendChild(media);
      }
      root.classList.add('is-playing');

      var playPromise = media.play && media.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }, { once: true });
  }

  function hydrateAll() {
    document.querySelectorAll('[data-cp-hero-video]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-cp-hero-video]').forEach(initHero);
  });
})();

/* === ra-cp-product-hotspots.js === */
/* Rod Armour — cp-product-hotspots responsive position hydrator (Opus 4.7 12-May)
   Extracted from inline <script> in sections/cp-product-hotspots.liquid.
   Each stage owns its dots; positions swap between desktop and mobile via media query. */
(function () {
  function initStage(stage) {
    if (stage.dataset.cpHotspotsHydrated === 'true') return;
    stage.dataset.cpHotspotsHydrated = 'true';

    var mq = window.matchMedia('(min-width: 1024px)');
    var dots = stage.querySelectorAll('[data-hot-dot]');

    function apply() {
      dots.forEach(function (d) {
        if (mq.matches) {
          d.style.top = d.dataset.vposD + '%';
          d.style.left = d.dataset.hposD + '%';
        } else {
          d.style.top = d.getAttribute('data-vpos-m') || d.style.top;
          d.style.left = d.getAttribute('data-hpos-m') || d.style.left;
        }
      });
    }

    dots.forEach(function (d) {
      if (!d.hasAttribute('data-vpos-m')) d.setAttribute('data-vpos-m', parseFloat(d.style.top));
      if (!d.hasAttribute('data-hpos-m')) d.setAttribute('data-hpos-m', parseFloat(d.style.left));
    });
    apply();
    mq.addEventListener('change', apply);
  }

  function hydrateAll() {
    document.querySelectorAll('[data-cp-hotspots-stage]').forEach(initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('[data-cp-hotspots-stage]').forEach(initStage);
  });
})();
